import type { PostHog } from 'posthog-js';
import { mergeEventContextProperties } from './analyticsContext';

/**
 * Registers tenant + space + role context as PostHog "super properties" so it's attached to
 * every event captured by the given client, including autocaptured events (e.g. `$pageview`) -
 * the PostHog equivalent of Amplitude's per-event `EnrichmentPlugin`.
 *
 * Unlike Amplitude's plugin (which re-reads live context at execute time), PostHog's
 * `register()` bakes the values in at call time — callers must re-invoke this whenever
 * tenant/space/role context changes (see `refreshRegisteredContext` in analyticsService.ts).
 */
export function registerTenantContext(client: PostHog): void {
	try {
		client.register(mergeEventContextProperties({}));
	} catch {
		// ignore
	}
}
